<template>
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div :class="modalContainerClass" class="modal-container">
              <slot name="absolute">
                  default absolute
                </slot>
              <div class="modal-header flex justify-center font-heading pt-16">
                <slot name="header">
                  default header
                </slot>
              </div>

              <div class="modal-body flex justify-center font-heading">
                <slot name="body">
                  default body
                </slot>
              </div>

              <div class="modal-footer flex justify-center font-heading pb-16">
                <slot name="footer">
                  default footer
                  <button class="btn secondary" @click="$emit('close')">
                    Confirm
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
    </transition>
</template>

<script>
export default {
  props: {
    modalContainerClass: {
      type: String,
      default: '',
    }
  }
}
</script>
